<template>
    <div class="cont-tit">
        <h2 class="page-title">Subscription Model</h2>
        <p class="page-desc">Here are our service subscription models to help you grow your business.</p>
    </div>
    <div class="subscription">
        <div class="subscription__box">
            <img src="../../assets/resource/img/Subscription-img02.png" class="subscription__img" alt="">
            <h2 class="subscription__tit">
                SaaS-BASED COMPLEX
                SERVICE-TYPE
                SUBSCRIPTION MODEL
            </h2>
            <p class="subscription__desc">
                Functions tailored to each industry's business size and a model that reduces initial costs while allowing easy service expansion through flexible rate plans. <br>
                Guaranteed global scalability through AWS cloud infrastructure.
            </p>
            <ul class="subscription__info-list">
                <li class="subscription__info-item">Provides step-by-step functions (basic, advanced package)</li>
                <li class="subscription__info-item">Flexible monthly/annual pricing</li>
                <li class="subscription__info-item">AWS-based cloud deployment</li>
            </ul>
        </div>
        <div class="subscription__box right">
            <div class="subscription__inner">
                <img src="../../assets/resource/img/Subscription-img01.png" class="subscription__img" alt="">
                <h2 class="subscription__tit">
                    MODULAR SaaS SERVICE
                </h2>
                <p class="subscription__desc">
                    Choose features that are tailored to your business needs <br>
                    Flexible service offerings that can be customized. <br>
                    Provides optimal solution for organic connection between function modules <br>
                    Support for specific industrial groups.
                </p>
                <ul class="subscription__info-list">
                    <li class="subscription__info-item">Required functions can be selected</li>
                    <li class="subscription__info-item">Organic connection between modules</li>
                    <li class="subscription__info-item">Customized service configuration</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>